define(
    'checkPreInit/errorActions',['atn/atn', './loadingErrors', 'common/config', 'dataSource/uiVersion', 'dataSource/logout'],
    function(atn, errors, commonConfig, uiVersion, logout) {
        'use strict';
        var actions = [{
            errors: [errors.NOT_HTTPS],
            action: reloadWithHttps
        }, {
            errors: [errors.FETCH_VERSION, errors.FETCH_SITE],
            fragment: '#site/failure/serverUnreachable'
        }, {
            errors: [errors.BUILD_MISMATCH],
            action: reloadWithNewBuild
        }, {
            errors: [errors.SERVER_API_MISMATCH, errors.SELF_API_MISMATCH, errors.NO_SSO_BACKEND],
            fragment: '#site/error'
        }, {
            errors: [errors.FOR_REPORTING],
            fragment: '#reporting'
        }, {
            errors: [errors.CAS_LOGIN],
            action: goToCASLogin
        }, {
            errors: [errors.LOCAL_LOGIN],
            fragment: '#site/logout'
        }, {
            errors: [errors.INVALID_TICKET],
            action: invalidTicketCasLogin
        }, {
            errors: [errors.CAS_SESSION_CREATE_FAILURE],
            fragment: '#site/failure/casSessionCreateFailed'
        }];

        actions.actuators = {
            reloadWithNewBuild: reloadWithNewBuild
        };

        return actions;

        function reloadWithHttps() {
            var constants = commonConfig.constants,
                newUrl = window.location.href.replace(
                    constants.PROTOCOL_HTTP,
                    constants.PROTOCOL_HTTPS
                );
            window.location.replace(newUrl);
        }

        function reloadWithNewBuild() {
            var requiredVersion = uiVersion.uiVersion.id,
                requiredURL = atn.utils.createURL(window.location.href, {
                    id: requiredVersion
                });
            atn.utils.redirect(requiredURL);
        }

        function goToCASLogin(data) {
            var urlParts = atn.utils.parseURL(window.location.href),
                casLoginURL = atn.utils.createURL(
                    data.errorData.redirectUrl,
                    urlParts.query,
                    urlParts.path
                );
            window.location.replace(casLoginURL);
        }

        function invalidTicketCasLogin(){
            var urlParts = atn.utils.parseURL(window.location.href);
            window.location.replace(urlParts.domain);
        }

    });
